import { render, staticRenderFns } from "./addChangeWorker.vue?vue&type=template&id=70b3389a&scoped=true&"
import script from "./addChangeWorker.vue?vue&type=script&lang=js&"
export * from "./addChangeWorker.vue?vue&type=script&lang=js&"
import style0 from "./addChangeWorker.vue?vue&type=style&index=0&id=70b3389a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3389a",
  null
  
)

export default component.exports